/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Row_Instead_OfInputs */

const en_us2_draft_row_instead_of = /** @type {(inputs: Draft_Row_Instead_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instead of`)
};

const pt_br2_draft_row_instead_of = /** @type {(inputs: Draft_Row_Instead_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No lugar de`)
};

const es_419_draft_row_instead_of = /** @type {(inputs: Draft_Row_Instead_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En lugar de`)
};

const pt_pt2_draft_row_instead_of = /** @type {(inputs: Draft_Row_Instead_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em vez de`)
};

const fr_fr2_draft_row_instead_of = /** @type {(inputs: Draft_Row_Instead_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À la place de`)
};

const de_de2_draft_row_instead_of = /** @type {(inputs: Draft_Row_Instead_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statt`)
};

const it_it2_draft_row_instead_of = /** @type {(inputs: Draft_Row_Instead_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al posto di`)
};

/**
* | output |
* | --- |
* | "Instead of" |
*
* @param {Draft_Row_Instead_OfInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_row_instead_of = /** @type {((inputs?: Draft_Row_Instead_OfInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Row_Instead_OfInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_row_instead_of(inputs)
	if (locale === "es-419") return es_419_draft_row_instead_of(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_row_instead_of(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_row_instead_of(inputs)
	if (locale === "de-DE") return de_de2_draft_row_instead_of(inputs)
	if (locale === "it-IT") return it_it2_draft_row_instead_of(inputs)
	return en_us2_draft_row_instead_of(inputs)
});
export { draft_row_instead_of as "draft.row_instead_of" }